import React from 'react';
import Login from 'pages/public/Login';
import VerifyOTP from 'pages/public/VerifyOTP';
import { Navigate, Route, Routes } from 'react-router-dom';
import { PublicRoutes as PublicRoutesDirectives } from './routeConstans';
import CreatePassword from 'pages/public/CreatePassword';
import PasswordSucess from 'pages/public/PasswordSucess';
import ForgotPassword from 'pages/public/ForgotPassword';
import ForgotPasswordSuccess from 'pages/public/ForgotPasswordSuccess';
import { MASTER_ENDPOINT } from 'utils/Constant';
import SSOLogin from 'pages/public/SSOLogin';
import ClientLogin from 'pages/public/ClientLogin';
import { addNewData } from 'services/CommonServices';
import Storage from 'utils/Storage';
import { jwtDecode } from 'jwt-decode';
import { useDispatch } from 'react-redux';
import { USER_LOGIN_SUCCESS } from 'store/types/UserTypes';

const PublicRoutes = () => {
  const dispatch: any = useDispatch();
 const queryParams = new URLSearchParams(window.location.search);
    const token = queryParams.get('token');
  
    if (token) {
      const userData: any = jwtDecode(String(token));
      addNewData(
        { employeeId: userData.Id },
        `${MASTER_ENDPOINT.GetEmployeeById}`,
        {},
        true,
      )
      .then((response: any) => {
        userData['token'] = token;
        userData['userDetailsData'] = response?.data;
        userData['isAdmin'] = false;
        userData['isClient'] = true;
        userData['isImpersonate'] = false;
        userData['isFromSuperAdmin'] = '';
        userData['superUserId'] = '';
        const tokenData: any = {
          refreshToken: '',
          token: token,
          userId: userData.id,
          isAdmin: false,
          isClient: true,
          isImpersonate: false,
          isFromSuperAdmin: '',
          superUserId: '',
        };

        Storage.setItem(Storage.KEYS.AUTH_TOKEN, JSON.stringify(tokenData));

        setTimeout(() => {
          dispatch({
            payload: userData,
            type: USER_LOGIN_SUCCESS,
          });
        }, 1000);
      })      
    }
  
  const {
    ADMINLOGIN,
    ADMINRESET,
    CLIENTLOGIN,
    CLIENTCOMPANYLOGIN,
    VERIFYADMIN,
    VERIFYCLIENT,
    CLIENTRESET,
    ADMINPASSWORDSUCESS,
    CLIENTPASSWORDSUCESS,
    FORGOTPASSWORDADMIN,
    FORGOTPASSWORDCLIENT,
    FORGOTPASSWORDSUCCESSCLIENT,
    FORGOTPASSWORDSUCCESSADMIN,
    SSOLOGIN
  } = PublicRoutesDirectives;
   if (token) {
    return(
      <SSOLogin></SSOLogin>
    )
   }
   else{
  return (
    <Routes>      
      <Route path={SSOLOGIN} element={<SSOLogin></SSOLogin>} />
      <Route path='/' element={<Navigate to={CLIENTLOGIN} replace />} />
      <Route path={ADMINLOGIN} element={<Login from={'admin'} />} />
      <Route path={ADMINRESET} element={<VerifyOTP from={'admin'} />} />
      <Route path={VERIFYADMIN} element={<CreatePassword from={'admin'} />} />
      <Route path={CLIENTLOGIN} element={<Login from={'client'} />} />
      <Route path={CLIENTRESET} element={<VerifyOTP from={'client'} />} />
      <Route path={VERIFYCLIENT} element={<CreatePassword from={'client'} />} />
      <Route path={ADMINPASSWORDSUCESS} element={<PasswordSucess from={'admin'} />} />
      <Route path={CLIENTPASSWORDSUCESS} element={<PasswordSucess from={'client'} />} />
      <Route path={FORGOTPASSWORDADMIN} element={<ForgotPassword from={'admin'} />} />
      <Route path={FORGOTPASSWORDCLIENT} element={<ForgotPassword from={'client'} />} />
      <Route path={FORGOTPASSWORDSUCCESSADMIN} element={<ForgotPasswordSuccess from={'admin'} />} />
      <Route
        path={FORGOTPASSWORDSUCCESSCLIENT}
        element={<ForgotPasswordSuccess from={'client'} />}
      />
      <Route path={CLIENTCOMPANYLOGIN} element={<ClientLogin />} />
      <Route path='*' element={<Navigate to={CLIENTLOGIN} />} />
    </Routes>
  );
}
};

export default PublicRoutes;
